<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងដៃគូសហការ</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<el-tabs v-model="tabName">
							<el-tab-pane label="ដៃគូសហការទាំងអស់" name="first"></el-tab-pane>
							<el-tab-pane label="បង្កើតដៃគូសហការថ្មី" name="second"></el-tab-pane>
						</el-tabs>
						<div v-if="tabName == 'first'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-40">
									<md-field>
										<label>ស្វែងរកដៃគូសហការដោយ​ឈ្មោះ លេខកូដ ឬចំណាំ</label>
										<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
									</md-field>
								</div>
				
								<div class="md-layout-item md-size-30">
									<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
								</div>
							</div>
				
							<md-table v-if="partnerList.length > 0">
								<md-table-row>
									<md-table-head>ល.រ</md-table-head>
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>ឈ្មោះ</md-table-head>
									<md-table-head>ភាគលាភត្រូវចែក</md-table-head>
									<md-table-head>ចំនួនរឿងសរុប</md-table-head>
									<md-table-head>ទឹកប្រាក់ត្រូវទូទាត់</md-table-head>
									<md-table-head>ចំណាំ</md-table-head>
									<md-table-head>កាលបរិច្ឆេទបង្កើត</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>
				
								<md-table-row v-for="(partner, index) in partnerList">
									<md-table-cell>{{ index + 1 }}</md-table-cell>
									<md-table-cell><b>{{ partner.hash }}</b></md-table-cell>
									<md-table-cell>{{partner.name}}</md-table-cell>
									<md-table-cell>{{ partner.dividend }}%</md-table-cell>
									<md-table-cell>
										<b v-if="partner.total_film != null">{{partner.total_film}}</b>
										<b v-else>0</b> រឿង
									</md-table-cell>
									<md-table-cell>{{ config.moneylify(partner.total_payment * partner.dividend / 100) }}</md-table-cell>
									<md-table-cell>{{ partner.note }}</md-table-cell>
									<md-table-cell>{{ config.datelify(partner.created_date)[1] }}</md-table-cell>
									<md-table-cell>
										<!-- <router-link :to="'/partners/detail/' + partner.hash">
											<md-button class="md-just-icon md-simple md-success">
												<md-icon>visibility</md-icon>
												<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
											</md-button>
										</router-link>
				 -->
										<router-link :to="'partners/edit/'+ partner.hash">
											<md-button class="md-just-icon md-simple md-info">
												<md-icon>edit</md-icon>
												<md-tooltip md-direction="top">កែប្រែព័ត៌មាន</md-tooltip>
											</md-button>
										</router-link>
										<md-button class="md-just-icon md-simple md-primary" @click="showPayAction(partner.hash)">
											<md-icon>price_check</md-icon>
											<md-tooltip md-direction="top">ទូទាត់</md-tooltip>
										</md-button>
									</md-table-cell>
								</md-table-row>
							</md-table>
				
							<h4 class="text-center" v-if="partnerList.length == 0 && loadMore == true">មិនមានដៃគូសហការ!</h4>
						</div>
				
				
				
						<div v-if="tabName == 'second'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-50">
									<div class="md-layout-item md-small-size-100 md-size-100">
										<h3>ព័ត៌មានដៃគូសហការ</h3>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-100 text-right">
										<span class="late">* តម្រូវបំពេញ</span>
									</div>
									<div class="md-layout">
										<div class="md-layout-item md-small-size-100 md-size-66">
											<md-field>
												<label>ឈ្មោះដៃគូសហការ *</label>
												<md-input type="text" v-model="partner.name"></md-input>
											</md-field>
										</div>
										<div class="md-layout-item md-small-size-100 md-size-33">
											<md-field>
												<label>ភាគលាភត្រូវចែក *</label>
												<md-input type="number" v-model="partner.dividend"></md-input>
											</md-field>
										</div>
										
										<div class="md-layout-item md-small-size-100 md-size-100">
											<md-field>
												<label>កំណត់ចំណាំ</label>
												<md-input type="text" v-model="partner.note">
												</md-input>
											</md-field>
										</div>
									</div>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<div class="md-layout-item md-small-size-100 md-size-100">
										<h3>ព័ត៌មានសង្ខេប</h3>
									</div>
									<div class="md-layout-item md-small-size-100 md-size-100">
										<md-table>
											<md-table-row>
												<md-table-cell style="width: 50%;">ឈ្មោះដៃគូសហការ</md-table-cell>
												<md-table-cell style="width: 5px">:</md-table-cell>
												<md-table-cell>
													<span v-if="String(partner.name).length > 0">{{partner.name}}</span>
													<span v-else>មិនមាន</span>
												</md-table-cell>
											</md-table-row>
											<md-table-row>
												<md-table-cell style="width: 50%;">ភាគលាភត្រូវចែក</md-table-cell>
												<md-table-cell style="width: 5px">:</md-table-cell>
												<md-table-cell>
													<span v-if="String(partner.dividend).length > 0">{{partner.dividend}}%</span>
													<span v-else>មិនមាន</span>
												</md-table-cell>
											</md-table-row>
											
											<md-table-row>
												<md-table-cell>កំណត់ចំណាំ</md-table-cell>
												<md-table-cell>:</md-table-cell>
												<md-table-cell>
													<span v-if="String(partner.note).length > 0">{{partner.note}}</span>
													<span v-else>មិនមាន</span>
												</md-table-cell>
											</md-table-row>
										</md-table>
									</div>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button class="md-raised md-primary" @click="postPartner()">បង្កើត</md-button>
								</div>
							</div>
				
						</div>
						<md-dialog-confirm :md-active.sync="payDialogActive" md-title="តើអ្នកពិតជាចង់ទូទាត់ទឹកប្រាក់ដៃគូសហការនេះមែនទេ ?"
							md-content="" md-confirm-text="ទូទាត់" md-cancel-text="បោះបង់"
							@md-cancel="onCancel" @md-confirm="onPay" />
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			window.scrollTo(0,0);
			this.searchHandler();

		},

		data() {
			return {
				tabName: "first",
				loaded: true,
				payDialogActive: false,
				paySelected: '',
				search: {
					text: "",
					gender: ""
				},
				partner: {
					valid: false,
					name: "",
					dividend: "",
					note: ""
				},
				loadMore: true,
				partnerList: []

			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/user/partner/search", {
					text: this.search.text,
					offset: more ? this.partnerList.length : 0
				}).then(data => {
					this.loaded = true;
					this.partnerList = more ? this.partnerList.concat(data.body.data) : data.body.data;
					if (data.body.data.length == 100) this.loadMore = true
					else this.loadMore = false
				})
			},
			postPartner() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/user/partner/post", {
					partner: this.partner
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "ដៃគូសហការត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
						this.clearAll();
					}
				})
			},
			
			checkValidation() {
				if (String(this.partner.name).length > 0 && String(this.partner.dividend).length > 0 && parseInt(this.partner.dividend) <= 100 && parseInt(this.partner.dividend) > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានបន្ថែម",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.search.gender = "";
				this.partner = {
					valid: false,
					name: "",
					note: "",
					dividend: ""
				}
			},
			showPayAction(id) {
				this.paySelected = id
				this.payDialogActive = true
			},
			onPay() {
				this.$http.post(this.config.api + "/user/partner/pay", {
					hash: this.paySelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ទឹកប្រាក់ដៃគូសហការបានទូទាត់ដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						
						this.searchHandler();
						this.onCancel();
						window.open("#/print_partner_payment/" + res.body.data.tx_hash, '_blank');
					}
				})
			},
			onCancel() {
				this.paySelected = ""
				this.payDialogActive = false
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Partners/View.vue